import {
  IQuery_Id,
} from '@kaidam/fc-shared/src/types/utils'

import {
  CreateReducer,
  CreateAction,
} from '../../store/utils/store'

import {
  getProjectHandlers,
} from '../../store/utils/api'

import {
  JobState,
  ReducerHandler,
  ThunkHandler,
} from '../../types/store'

import {
  IPubsub_Message_Type_Job,
  IPubsub_Message_Body_Job,
  IPubsub_Message_Body_Job_Log,
  IPubsub_Message_Body_Job_Update,
} from '@kaidam/fc-shared/src/types/pubsub'

import {
  IPayload_Job_Logs,
} from '../../types/job'

import {
  IRecord_Job,
} from '@kaidam/fc-shared/src/types/schema/job'

import {
  NetworkThunk,
} from '../utils/network'

import {
  getSocketClientFactory,
} from '../../store/utils/websocket'

import {
  waitForJob as waitForJobUtil,
} from '@kaidam/fc-shared/src/pubsub/utils'

import {
  getJobChannel,
} from '@kaidam/fc-shared/src/pubsub/channels'

import {
  PUBSUB_MESSAGE_TYPE_JOB_LOG,
  PUBSUB_MESSAGE_TYPE_JOB_UPDATE,
} from '@kaidam/fc-shared/src/constants'

const getJobSocket = getSocketClientFactory<
  IPubsub_Message_Type_Job,
  IPubsub_Message_Body_Job
>()

const prefix = 'job'

/*

  initial state

*/
const initialState: JobState = {
  jobs: {},
  logs: {},
}

/*

  reducers

*/
const setJob: ReducerHandler<JobState, IRecord_Job> = (state, action) => {
  const job = action.payload
  state.jobs[job.id] = job
}

const setLogs: ReducerHandler<JobState, IPayload_Job_Logs> = (state, action) => {
  const {
    id,
    logs,
  } = action.payload
  state.logs[id] = logs
}

const addLogs: ReducerHandler<JobState, IPayload_Job_Logs> = (state, action) => {
  const {
    id,
    logs,
  } = action.payload
  const existing = state.logs[id] || []
  state.logs[id] = existing.concat(logs)
}

/*

  thunks

*/
const getJob: ThunkHandler<IQuery_Id, void> = (payload) => async (dispatch, getState) => {
  const handlers = getProjectHandlers(getState)
  const data = await handlers.get<IRecord_Job>(`/job/${payload.id}`)
  dispatch(actions.setJob(data))
}

const getLogs: ThunkHandler<IQuery_Id, void> = (payload) => async (dispatch, getState) => {
  const handlers = getProjectHandlers(getState)
  const logs = await handlers.get<string[]>(`/job/${payload.id}/logs`)
  dispatch(actions.setLogs({
    id: payload.id,
    logs,
  }))
}

const subscribeToJob: ThunkHandler<string, boolean> = (id) => async (dispatch, getState) => {
  const channel = getJobChannel(id)
  const socket = getJobSocket()
  dispatch(actions.setLogs({
    id,
    logs: []
  }))
  await socket.subscribe(channel, async (message) => {
    if(message.messageType == PUBSUB_MESSAGE_TYPE_JOB_LOG) {
      const logs = message.body as IPubsub_Message_Body_Job_Log
      dispatch(actions.addLogs({
        id,
        logs,
      }))
    }
    else if(message.messageType == PUBSUB_MESSAGE_TYPE_JOB_UPDATE) {
      const data = message.body as IPubsub_Message_Body_Job_Update
      dispatch(actions.setJob(data))
    }
  })
  return true
}

const unsubscribeToJob: ThunkHandler<string, boolean> = (id) => async (dispatch, getState) => {
  const channel = getJobChannel(id)
  const socket = getJobSocket()
  socket.unsubscribe(channel)
  return true
}

const waitForJob: ThunkHandler<string, boolean> = (id) => async (dispatch, getState) => {
  const socket = getJobSocket()
  await waitForJobUtil(
    socket,
    id,
    () => {},
  )
  return true
}

/*

  collections

*/
const reducers = {
  setJob,
  setLogs,
  addLogs,
}

export const actions = {

  /*
  
    reducers
  
  */
  setJob: CreateAction(prefix, `setJob`, setJob),
  setLogs: CreateAction(prefix, `setLogs`, setLogs),
  addLogs: CreateAction(prefix, `addLogs`, addLogs),
  
  getJob: NetworkThunk(prefix, 'getJob', getJob, {
    snackbar: true,
  }),
  getLogs: NetworkThunk(prefix, 'getLogs', getLogs, {
    snackbar: true,
  }),
  subscribeToJob: NetworkThunk(prefix, 'subscribeToJob', subscribeToJob, {
    snackbar: true,
  }),
  unsubscribeToJob: NetworkThunk(prefix, 'unsubscribeToJob', unsubscribeToJob, {
    snackbar: true,
  }),
  waitForJob: NetworkThunk(prefix, 'waitForJob', waitForJob, {
    snackbar: true,
  }),
}

export const reducer = CreateReducer<JobState>({
  prefix,
  initialState,
  reducers,
})

export default actions